export default __webpack_public_path__ + "media/images/missing_male_medium-b8eecd689c2316729b6246de7f2c0c4e.png";